import { useDispatch } from 'react-redux'
import { managementSelectors, useTypedSelector } from '../../../store'
import * as managementActions from '../../../store/management/actions'

function ContentOverlay() {
  const dispatch = useDispatch()
  const editingEntityId = useTypedSelector(({ management }) =>
    managementSelectors.getEditingEntityId(management),
  )
  const isGlobalSettingsEditing = useTypedSelector(({ management }) =>
    managementSelectors.isGlobalSettingsEditing(management),
  )
  const isOverlayVisible = editingEntityId || isGlobalSettingsEditing

  const closeSettings = () => {
    if (isGlobalSettingsEditing) {
      dispatch(managementActions.setGlobalSettingsEditing(false))
    } else if (editingEntityId) {
      dispatch(managementActions.setEditingEntityId(null))
    }
  }

  return isOverlayVisible ? <div className="absolute inset-0" onClick={closeSettings} /> : null
}

export default ContentOverlay
